module.exports = __webpack_public_path__ + "thumbnail-b8dfbf546bb1c8533f5d665c74d575de.png";